import React, { useEffect, useState } from 'react';
import { pathname, formatNumber } from '../../../../utils';
import { requestResponse } from '../Requests';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import LoadingButton from '../../../lowLevel/LoadingButton';
import AdminFreeText from './AdminFreeText';

const useStyles = makeStyles((theme: any) => ({
  logo: { width: 70, marginBottom: '10px', marginTop: '40px' },
  topMargin: {
    marginTop: theme.spacing(2),
    fontWeight: 'bold',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  bottomMargin: {
    marginBottom: theme.spacing(2),
  },
  button: {
    fontSize: 'large',
    minWidth: 175,
  },
  secondaryButton: {
    fontSize: 'large',
    minWidth: 175,
    backgroundColor: theme.palette.brand.grey,
  },
}));

export default function PendingCustomerApproval({
  request,
  showResponse,
  loading,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [daysLeft, setDaysLeft] = useState(7);
  const [approving, setApproving] = useState(false);
  const [rejecting, setRejecting] = useState(false);

  useEffect(() => {
    const diff2 = moment(request.updated_at).add(8, 'days');
    const diff = diff2.diff(moment(), 'days');
    setDaysLeft(diff);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const approveRequest = async () => {
    setApproving(true);
    await showResponse(requestResponse.customerApproved);
    setApproving(false);
  };

  const rejectPaymentChangeRequest = async () => {
    setRejecting(true);
    await showResponse(requestResponse.customerPaymentChangeRejected);
    setRejecting(false);
  };

  const redirectToPlan = () => {
    history.push(pathname.plans.url);
  };

  const subtractOrAdd = (payment) => {
    if (payment > 0) return 'added to';
    else return 'subtracted from';
  };

  function renderFinancingApplicationApproval() {
    return (
      <>
        <Typography variant="h5" className={classes.topMargin}>
          Summary
        </Typography>
        <Typography variant="h6">
          Onces applied, your requested changes will result in:
        </Typography>
        {request?.total_requested && (
          <Typography variant="h6">
            ${formatNumber(Math.abs(request?.total_requested))}{' '}
            {subtractOrAdd(request?.total_requested)} COGS
          </Typography>
        )}
        {request?.cost_of_capital && (
          <Typography variant="h6">
            ${formatNumber(Math.abs(request?.cost_of_capital))}{' '}
            {subtractOrAdd(request?.cost_of_capital)} Cost of Capital
          </Typography>
        )}
        {request?.total_participation && (
          <Typography variant="h6" className={classes.bottomMargin}>
            ${formatNumber(Math.abs(request?.total_participation))}{' '}
            {subtractOrAdd(request?.total_participation)} Participation
          </Typography>
        )}
      </>
    );
  }

  function renderPaymentApproval() {
    return (
      <>
        <Typography variant="h5" className={classes.topMargin}>
          Your Request was Approved
        </Typography>
        <Typography variant="h6">
          Once applied, your requested changes will result in: $
          {formatNumber(Math.abs(request.new_amount))} added to your remittance.
          Please note, this difference in cost stems from a risk reevaluation.
        </Typography>
      </>
    );
  }

  return (
    <DialogContent className={classes.root}>
      <img src={'./icons/edit.svg'} className={classes.logo} alt="edit logo" />
      {request.type === 'financing_application' &&
        renderFinancingApplicationApproval()}
      {request.type === 'payment' && renderPaymentApproval()}
      <AdminFreeText freeText={request?.admin_free_text} center={true} />
      <DialogActions>
        <LoadingButton
          variant="contained"
          className={classes.button}
          color="primary"
          onClick={approveRequest}
          loading={approving}
          disabled={loading}
        >
          <b>
            Accept {'('}
            {daysLeft} days left{')'}
          </b>
        </LoadingButton>
      </DialogActions>
      {request.type === 'payment' && (
        <DialogActions>
          <LoadingButton
            className={classes.secondaryButton}
            onClick={rejectPaymentChangeRequest}
            loading={rejecting}
            disabled={loading}
          >
            <b>Stay on Current Funds Deliveries</b>
          </LoadingButton>
        </DialogActions>
      )}
      {request.type === 'financing_application' && (
        <DialogActions>
          <Button className={classes.secondaryButton} onClick={redirectToPlan}>
            <b>View Full Details in 'Plans'{'>'}</b>
          </Button>
        </DialogActions>
      )}
    </DialogContent>
  );
}
